import {Injectable} from '@angular/core';
import {isErrorResponse, isIdentificationResponse, OptionalIdentification} from './api.service';

@Injectable()
export class IdentificationService {

  email: string | null = null;
  error: string | null = null;    // 'account_inactive' | 'not_found' | 'unknown' | 'verify_email'
  username: string | null = null; // TODO keep this here?

  constructor() {
  }

  handleResponse(email: string, response: OptionalIdentification<any>): void {
    this.email = email;
    if (isIdentificationResponse(response)) {
      this.username = response.username;
    } else if (isErrorResponse(response)) {
      this.error = response.error;
    }
  }

  reset() {
    this.email = null;
    this.error = null;
    this.username = null;
  }
}
